<template>
  <v-container v-if="acceptance">
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat class="rounded-card">
      <v-card-title>
        受入詳細
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <div class="overline">
              受入番号
            </div>
            <h4>{{ acceptance.carrying_no }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              受入日（予定日）
            </div>
            <h4>{{ acceptance.carrying_plan_date | date_format }}&emsp;{{ acceptance.carrying_plan_start_time | from_to_linked_time(acceptance.carrying_plan_end_time, ' 〜 ') }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2">
            <div class="overline">
              受入日
            </div>
            <h4>{{ acceptance.carried_date | date_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="acceptance.manifests"
          dense
          hide-default-footer
          disable-sort
          :items-per-page="-1"
        >
          <!-- 排出事業者 -->
          <template v-slot:[`item.emission`]="{ item }">
            {{ item.emission.name }}
          </template>
          <!-- /排出事業者 -->
          <!-- 排出事業場 -->
          <template v-slot:[`item.emission_location`]="{ item }">
            {{ item.emission_location.name }}
          </template>
          <!-- /排出事業場 -->
          <!-- マニフェスト数量 -->
          <template v-slot:[`item.quantity`]="{item}">
            {{ item.quantity | comma_format }}
          </template>
          <!-- /マニフェスト数量 -->
          <!-- 廃棄物の確定数量 -->
          <template v-slot:[`item.fixed_quantity`]="{item}">
            {{ item.fixed_quantity | comma_format }}
          </template>
          <!-- /廃棄物の確定数量 -->
          <!-- 受入量 -->
          <template v-slot:[`item.receive_quantity`]="{item}">
            {{ item.receive_quantity | comma_format }}
          </template>
          <!-- /受入量 -->
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="backButtonClickEvent"
        >
          戻る
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DriverAcceptance',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [],
      acceptance: null,
      tableHeaders: [
        { value: 'manifest_no', text: 'マニフェスト番号' },
        { value: 'emission', text: '排出事業者' },
        { value: 'emission_location', text: '排出事業場' },
        { value: 'item_name', text: '品目' },
        { value: 'quantity', text: 'マニフェスト数量', align: 'end' },
        { value: 'quantity_unit', text: '数量単位' },
        { value: 'fixed_quantity', text: '廃棄物の確定数量', align: 'end' },
        { value: 'fixed_quantity_unit', text: '数量単位' },
        { value: 'receive_quantity', text: '受入量', align: 'end' },
        { value: 'receive_quantity_unit', text: '数量単位' },
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    this.breadcrumbs = []

    if (this.$route.query.d !== undefined) {
      this.breadcrumbs.push({ text: 'ダッシュボード', disabled: false, to: '/driver/home', exact: true })
    } else {
      this.breadcrumbs.push({ text: '処分場受入一覧', disabled: false, to: '/driver/acceptances', exact: true })
    }
    this.breadcrumbs.push({ text: '受入の詳細', disabled: true, to: '' })

    this.fetchAcceptance({ id: this.$route.params.id }).then((content) => {
      this.acceptance = content
    })

},
  methods: {
    ...mapActions('DriverAcceptance', {
      fetchAcceptance: 'show'
    }),
    backButtonClickEvent () {
      if (this.$route.query.d !== undefined) {
        this.$router.push( { name: 'DriverDashboard' } )
      } else {
        this.$router.push( { name: 'DriverAcceptances' } )
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
